import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectRecordText = createSelector(
  [(store: RootState) => store.fichaMiDt.recordText],
  (data) => data
);
